import React from 'react';

import { PromoFlagIcon } from 'apps/promo/components/common/promo-flag-icon/PromoFlagIcon';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { getHighlightedText } from 'apps/promo/helpers/utils';

import { DropdownCountryCurrency, DropdownCountryName, DropdownListItem, DropdownListItemContent } from './styles';

const PromoCountryItem = React.forwardRef((props, ref) => {
    const { country } = props;
    const availableCurrencies = country.currencies.filter((currency) => currency[props.direction]);

    const currency = (currencies, query) => {
        return currencies.map((currency) => {
            return (
                <DropdownCountryCurrency key={currency?.id}>
                    {!!query ? (
                        <>
                            {getHighlightedText(query, currency.code, 'promoText', {
                                basicColor: 'gray40',
                                variant: 'subheader',
                                ellipsis: true,
                            })}
                        </>
                    ) : (
                        <PromoText variant="subheader" color="gray40" ellipsis>
                            {currency.code}
                        </PromoText>
                    )}
                </DropdownCountryCurrency>
            );
        });
    };

    return (
        <DropdownListItem ref={ref} onClick={() => props.handleCountrySelection(country, availableCurrencies)} tabIndex={'0'} $isSelected={props.isSelected}>
            <DropdownListItemContent>
                <PromoFlagIcon name={country.code.toLowerCase()} />
                <DropdownCountryName>
                    {!!props.query ? (
                        <>
                            {getHighlightedText(props.query, country.name, 'promoText', {
                                basicColor: 'gray80',
                                variant: 'subheader',
                            })}
                        </>
                    ) : (
                        <PromoText variant="subheader" color="gray80">
                            {country.name}
                        </PromoText>
                    )}
                </DropdownCountryName>
            </DropdownListItemContent>
            {props.showCurrencies && <>{currency(availableCurrencies, props.query)}</>}
        </DropdownListItem>
    );
});

export default PromoCountryItem;
